import { type SmartLinkResponse } from '@atlaskit/linking-types';

import { extractEntity } from './extract-entity';

export const isEntityPresent = (response?: SmartLinkResponse): boolean =>
	Boolean(extractEntity(response));
